import { render, staticRenderFns } from "./InfoArea.vue?vue&type=template&id=09ac49bc&"
import script from "./InfoArea.vue?vue&type=script&lang=ts&"
export * from "./InfoArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports